// extracted by mini-css-extract-plugin
export default {"header-page":"ClientListPage_header-page__csvbr","header-page__search":"ClientListPage_header-page__search__qtjzR"};